export default __webpack_public_path__ + "images/4a0f21055361e701da6a31761b0f6d6c-badge-screening-color.svg";